import _ from 'lodash';
import template from './stavkaNalogaForm.html';
import { kvadrant_I } from './kvadrant.js';
import { kvadrant_II } from './kvadrant.js';
import { kvadrant_III } from './kvadrant.js';
import { kvadrant_IV } from './kvadrant.js';

class StavkaNalogaFormController {
    constructor(AppConfiguration, DS, $timeout, logger, $q) {
        this.item = this.resolve.item;
        this.logger = logger;
        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
        this.datastore = () => DS;
        this.$timeout = () => $timeout;
        this.$q = () => $q;
    }

    $onInit() {
        const DS = this.datastore();
        const $q = this.$q();
        this.vrste_radova = [];
        this._materijali = []; // cache materijala za kasnije filtriranje
        this.stavke_cjenika = [];
        this.clone = angular.copy(this.item);
        DS.findAll('StavkaCjenika').then(stavke => {
            this.stavke_cjenika = stavke;

            DS.findAll('ProtetskiRad')
                .then(response => {
                    this.protetski_rad = response.filter(i => {
                        return _.find(this.stavke_cjenika, { protetski_rad: i.id });
                    });
                })
                .then(() => {
                    $q.when(DS.findAll('VrstaRada')).then(vrsta => {
                        this.vrste_radova = vrsta.filter(i => {
                            return _.find(this.protetski_rad, { vrsta_rada: i.id });
                        });
                    });
                });
            DS.findAll('Materijal').then(response => {
                this._materijali = response;
            });
        });
    }

    submit(model) {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.close({ $value: model });
    }

    setVrstuRada(item) {
        if (item === undefined) {
            this.clone.vrsta_rada = undefined;
            this.materijali = [];
            return;
        }

        const $timeout = this.$timeout();
        const radovi = _.filter(this.protetski_rad, { vrsta_rada: item.id });

        this.clone.vrsta_rada = null;
        this.clone.protetski_rad = null;
        this.clone.cjenik = null;
        const materijali = [];

        _.forEach(radovi, rad => {
            if (rad.materijal) {
                materijali.push(rad.materijal);
            }
        });

        if (materijali.length === 0) {
            this.setProtetskiRadByVrstaRada(item.id);
        }

        $timeout(() => {
            this.clone.vrsta_rada = item.id;
            this.materijali = _.uniq(materijali).map(m => {
                return _.cloneDeep(_.find(this._materijali, { id: m }));
            });
        });
    }

    setMaterijal(item) {
        // const $timeout = this.$timeout();
        // this.setProtetskiRadByVrstaRadaAndMaterijal(this.clone.vrsta_rada, item.id);
        if (item && _.isFinite(parseInt(item.id))) {
            this.clone.materijal = item.id;
        } else {
            this.clone.materijal = undefined;
        }
        // $timeout(() => {
        // });
    }

    setProtetskiRadByVrstaRada(vrsta_rada) {
        // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada});
        // if (_.isUndefined(protetski_rad)) {
        //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
        //     return;
        // }
        // this.clone.protetski_rad = protetski_rad.id;
        // this.setCjenik(this.clone.protetski_rad);
    }

    setProtetskiRadByVrstaRadaAndMaterijal(vrsta_rada, materijal) {
        // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada, materijal: materijal});
        // if (_.isUndefined(protetski_rad)) {
        //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
        //     return;
        // }
        // this.clone.protetski_rad = protetski_rad.id;
        // this.setCjenik(this.clone.protetski_rad);
    }

    setCjenik(protetski_rad) {
        const stavke = _.filter(this.stavke_cjenika, { protetski_rad: protetski_rad });
        debugger;
        if (stavke.length === 1) {
            this.clone.cjenik = stavke[0].cjenik;
        }
    }

    cancel() {
        this.dismiss({ $value: 'cancel' });
    }
}

StavkaNalogaFormController.$inject = ['AppConfiguration', 'DS', '$timeout', 'logger', '$q'];

const StavkaNalogaFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: StavkaNalogaFormController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};

export { StavkaNalogaFormComponent };
export { StavkaNalogaFormController };



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/stavkaNalogaForm.component.js